// extracted by mini-css-extract-plugin
module.exports = {"loader":"styles_loader__1FSNB","cardHeader":"styles_cardHeader__3Q2-0","headerButtons":"styles_headerButtons__1wTJ1"};